<script>
  import formatPrice from '../../helpers/formatPrice';
  import { locale } from 'svelte-intl';
  import { noop } from "svelte/internal";
  import CoinsAmount from './CoinsAmount.svelte';

  export let bundle; // Bundle
  export let onSelect = noop; // (bundle: Bundle) => void

  $: priceCurrency = bundle.priceCurrency;
  $: priceAmount = bundle.priceAmount;
</script>

<style lang="stylus">
  li
    cursor: pointer
    border-radius: 8px
    box-shadow 0px 3px 10px rgba(38, 38, 38, 0.1)
    display: flex
    align-items: center
    padding: 14px
    font-size 20px

  div
    line-height 24px

  li:not(:last-child)
    margin-bottom: 16px

  .price
    background: #F5F5F5
    border-radius: 100px
    margin-left: auto
    color: $lighter-grey
    padding: 7px 21px
    font-size 16px
    line-height 20px
</style>

<li on:click={onSelect(bundle)}>
  <div>
    <CoinsAmount {bundle} />
  </div>
  <div class="price">
    {formatPrice($locale, bundle.priceCurrency, bundle.priceAmount / 100)}
  </div>
</li>
